export const namespace = 'featureFlagConfig';

export const Status = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error'
}

export const ActionType = {
  SET_FEATURE_FLAG_CONFIG: `${namespace}/SET_FEATURE_FLAG_CONFIG`,
}

export const setFeatureFlagConfig = (featureFlagConfig = []) => ({
  type: ActionType.SET_FEATURE_FLAG_CONFIG,
  payload: {
    featureFlagConfig
  }
})
